import { render, staticRenderFns } from "./c-language-switcher.vue?vue&type=template&id=6394f198&"
import script from "./c-language-switcher.vue?vue&type=script&lang=js&"
export * from "./c-language-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports